export default "__VITE_ASSET__6jfGa1gN__"